import { render } from "./volume.vue?vue&type=template&id=1dccdb7d&scoped=true"
import script from "./volume.vue?vue&type=script&lang=js"
export * from "./volume.vue?vue&type=script&lang=js"

import "./volume.vue?vue&type=style&index=0&id=1dccdb7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dccdb7d"]])

export default __exports__